import { CHAT_NOTIFICATION_CATEGORIES } from "PFApp/constants/notifications";
import { NOTIFICATIONS_PANEL_ID } from "PFApp/notifications/constants";
import { useAppLayoutStore, useAppLayoutStoreActions } from "PFApp/stores/app_layout_store";
import { useNotifications } from "PFCore/hooks/queries/notifications/use_notifications";
import { useTranslation } from "react-i18next";

import { CommonNavItemProps, NavItem } from "../parts/nav_item";

export const NotificationsNavItem = (props: CommonNavItemProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "navBar.items" });
  const leftActionPanel = useAppLayoutStore((state) => state.leftActionPanel);
  const { setLeftActionPanel } = useAppLayoutStoreActions();

  const { data: notifications } = useNotifications({
    perPage: 0,
    excludedCategories: CHAT_NOTIFICATION_CATEGORIES
  });

  const totalUnread = notifications?.meta.totalUnread || 0;

  const isOpen = !leftActionPanel.collapsed && leftActionPanel.id === NOTIFICATIONS_PANEL_ID;

  return (
    <NavItem
      icon="notifications"
      name={t("notifications")}
      id="notifications"
      onClick={() => {
        if (isOpen) {
          setLeftActionPanel({ id: NOTIFICATIONS_PANEL_ID, collapsed: true });
        } else {
          setLeftActionPanel({ id: NOTIFICATIONS_PANEL_ID, collapsed: false });
        }
      }}
      forceOpen={isOpen}
      counter={totalUnread}
      {...props}
    />
  );
};
